<div class="rounded-2.5xl w-full">
  <!-- Header -->
  <div
    class="md:p-12 px-12 py-6 border-gray-300 border-b text-gray-600 text-center">
    <h1 class="text-xl md:text-3xl xl:text-4xl" [innerHTML]="title()"></h1>
  </div>
  <!-- <hr> -->
  <!-- Body -->
  <div id="ScrollBox" class="px-12 md:px-24 py-6 antialiased masked">
    <h4 class="pt-5 font-poppins text-gray-600">
      The following seats have restrictions, check for them:
    </h4>
    <ul
      class="mt-2 mb-1 pb-3"
      style="
        list-style-type: disc;
        padding-left: 20px;
        max-height: 400px;
        overflow-y: auto;
      ">
      @for (seat of seats(); track seat.id) {
        <li>
          <span>
            Section: {{ seat.section.split('_')[1] }} Row:
            {{ seat.seat_row }} Seat:
            {{ seat.seat }}
          </span>
          <ul style="list-style-type: circle; padding-left: 20px">
            @for (esd of seat.definitions; track esd.id) {
              <ng-container>
                @if (esd.restriction) {
                  <li>
                    <span>
                      {{ esd.description }}
                    </span>
                  </li>
                  <br />
                }
              </ng-container>
            }
          </ul>
        </li>
      }
    </ul>
  </div>
  <div
    class="px-12 md:px-24 py-6 md:py-12 border-gray-300 border-t text-center">
    <div class="flex justify-center">
      <sdc-button
        class="gs-modal-btn--outline"
        className="disabled:opacity-30 mr-3 md:mr-6 !w-28 min-w-max h-10 disabled:hover:transform-none hover:scale-95 transition-transform"
        theme="theme-sdc"
        variant="outline"
        (onClick)="close()">
        Close
      </sdc-button>
      <sdc-button
        class="gs-modal-btn--primary"
        className="disabled:opacity-30 mr-3 md:mr-6 !w-28 min-w-max h-10 disabled:hover:transform-none hover:scale-95 transition-transform"
        theme="theme-sdc"
        variant="primary"
        (onClick)="continue()">
        Continue
      </sdc-button>
    </div>
  </div>
</div>
